import request from '@/utils/request'

//忘记密码第一步
export function register(query) {
  return request({
    url: '/register/registerdo',
    method: 'post',
    params: query,
  })
}

// 登录
export function login(query) {
  return request({
    url: '/login/logindo',
    method: 'post',
    params: query,
  })
}

//获取手机验证码
export function smsCode(query) {
  return request({
    url: '/register/check_and_sendsms',
    method: 'post',
    params: query,
  })
}

//忘记密码第一步
export function forgetStep1(query) {
  return request({
    url: '/forget/step1',
    method: 'post',
    params: query,
  })
}

//忘记密码第二步
export function forgetStep2(query) {
  return request({
    url: '/forget/step2',
    method: 'post',
    params: query,
  })
}

//忘记密码第三步
export function forgetStep3(query) {
  return request({
    url: '/forget/step3',
    method: 'post',
    params: query,
  })
}

//忘记密码第三步
export function changePwd(query) {
  return request({
    url: '/forget/change_password',
    method: 'post',
    params: query,
  })
}

//退出登录
export function loginOut(query) {
  return request({
    url: '/log/off',
    method: 'post',
  })
}




// WEBPACK FOOTER //
// ./src/api/login/index.js